__webpack_require__.p = "https://dev.reporting.agids.amazon.dev/";